import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/style.css';
import './index.css';
import './font-awesome/css/font-awesome.min.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import LogIn from './LogInRegister/LogIn';
import Register from './LogInRegister/Register';
import Navbar from './AdminPage/Navbar';
import Footer from './AdminPage/Footer';
import Profile from './AdminPage/Profile';
import ProtectedRoute from '../src/ProtectedRoute';
import CogenerationPage from './AdminPage/Cogeneration/CogenerationPage';
import DashboardPage from './AdminPage/Dashboard/DashboardPage';
import AddCogeneration from './AdminPage/Cogeneration/AddCogeneration/AddCogeneration';
import EditCogenplant from './AdminPage/Cogeneration/UpdateCogeneration/EditCogenplant';
import ClassifiedPage from './AdminPage/Classifieds/ClassifiedPage';
import AddClassifiedPage from './AdminPage/Classifieds/AddClassified/AddClassifiedPage';
import EditClassifiedPage from './AdminPage/Classifieds/UpdateClassified/EditClassifiedPage';
import SupplierPage from './AdminPage/Suppliers/SuppliersPage';
import AddSupplierPage from './AdminPage/Suppliers/AddSupplier/AddSupplierPage';
import EditSupplierPage from './AdminPage/Suppliers/UpdateSupplier/EditSupplierPage';
import CogenDashboardPage from './AdminPage/CogenDashboard/CogenDashboardPage';
import OfficialsPage from './AdminPage/Officials/OfficialsPage';
import TechnicalPage from './AdminPage/Technical/TechnicalPage';
import PerformDataPage from './AdminPage/PerformData/PerformDataPage';
import AddNewPerformanceData from './AdminPage/PerformData/AddPerformData/AddPerformDataPage';
import EditPerformDataPage from './AdminPage/PerformData/UpdatePerformData/EditPerformDataPage';
import AddTechnicalPage from './AdminPage/Technical/AddTechnical/AddTechnicalPage';
import EditTechnicalPage from './AdminPage/Technical/UpdateTechnical/EditTechnicalPage';
import AddOfficialsPage from './AdminPage/Officials/AddOfficials/AddOfficialsPage';
import EditOfficialsPage from './AdminPage/Officials/UpdateOfficials/EditOfficialsPage';
import BannerPage from './AdminPage/Banners/BannerPage';
import AddBannersPage from './AdminPage/Banners/AddBanners/AddBannersPage';
import ViewBannerPage from './AdminPage/Banners/ViewBanner/ViewBannerPage';
import PowerGenerationPage from './AdminPage/PowerGeneration/PowerGenerationPage';
import AddPowerGenerationPlantPage from './AdminPage/PowerGeneration/AddPowerGeneration/AddPowerGenerationPlantPage';
import UpdatePowerGenerationPlantPage from './AdminPage/PowerGeneration/UpdatePowerGeneration/UpdatePowerGenerationPlantPage';
import EditPowerOfficials from './AdminPage/PowerOfficials/UpdatePowerOfficials/EditPowerOfficialsPage';
import RenewableAgencyPage from './AdminPage/RenewableAgency/RenewableAgencyPage';
import AddRenewableAgencyPage from './AdminPage/RenewableAgency/AddRenewableAgency/AddRenewableAgencyPage';
import UpdateRenewableAgencyPage from './AdminPage/RenewableAgency/UpdateRenewableAgency/UpdateRenewableAgencyPage';
import AgencyOfficialsPage from './AdminPage/AgencyOfficials/AgencyOfficialsPage';
import RenewableEnergyPage from './AdminPage/RenewableEnergy/RenewableEnergyPage';
import AddRenewableEnergyPage from './AdminPage/RenewableEnergy/AddRenewableEnergy/AddRenewableEnergyPage';
import UpdateRenewableEnergyPage from './AdminPage/RenewableEnergy/UpdateRenewableEnergy/UpdateRenewableEnergyPage';
import PowerDashboardPage from './AdminPage/PowerDashboard/PowerDashboardPage';
import PowerPerformanceDataPage from './AdminPage/PowerPerformanceData/PowerPerformanceDataPage';
import AddPerformanceDataPage from './AdminPage/PowerPerformanceData/AddPerformanceData/AddPerformanceDataPage';
import EditPerformanceDataPage from './AdminPage/PowerPerformanceData/UpdatePerformanceData/EditPerformanceDataPage';
import AgencyDashboardPage from './AdminPage/RenewableAgencyDashboard/AgencyDashboardPage';
import AddNewAgencyOfficialsPage from './AdminPage/AgencyOfficials/AddAgencyOfficials/AddNewAgencyOfficialsPage';
import EditAgencyOfficialsPage from './AdminPage/AgencyOfficials/UpdateAgencyOfficials/EditAgencyOfficialsPage'; 
import EnergyDashboardPage from './AdminPage/RenewableEnergyDashboard/EnergyDashboardPage';
import EnergyOfficialPage from './AdminPage/EnergyOfficials/EnergyOfficialPage';
import AddNewEnergyOfficialsPage from './AdminPage/EnergyOfficials/AddEnergyOfficials/AddNewEnergyOfficialsPage';
import EditEnergyOfficialsPage from './AdminPage/EnergyOfficials/UpdateEnergyOfficials/EditEnergyOfficialsPage';
import AddPowerOfficialsPage from './AdminPage/PowerOfficials/AddPowerOfficials/AddPowerOfficialsPage';
import PowerOfficials from './AdminPage/PowerOfficials/PowerOfficialPage';
// ✅ Layout Wrapper Component
function LayoutWrapper({ children }) {
  const location = useLocation();
  const hideLayoutRoutes = ["/login", "/register"];
  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <div className="app-container">
      {!shouldHideLayout && <Navbar />}
      <div className="main-content">{children}</div>
      {!shouldHideLayout && <Footer />}
    </div>
  );
}
// ✅ Main App Component
function App() {
  return (
    <LayoutWrapper>
      <Routes>
        {/* ✅ Default Route */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* ✅ Public Routes */}
        <Route path="/login" element={<LogIn />} />
        <Route path="/register" element={<Register />} />

        {/* Admin Routes */}
        <Route path="/Admin" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/cogeneration" element={<ProtectedRoute>  <CogenerationPage /></ProtectedRoute>} />
        <Route path="/addcogeneration"  element={<ProtectedRoute> <AddCogeneration /></ProtectedRoute>} />
        <Route path="/editcogeneration/:plantName/:id"  element={<ProtectedRoute> <EditCogenplant /> </ProtectedRoute> } />
        <Route path="/cogendashboard/:plantName/:id"element={
                  <ProtectedRoute> <CogenDashboardPage /></ProtectedRoute>
                  } />
        <Route path="/cogenplant-officials/:plantName/:id" element={
              <ProtectedRoute> <OfficialsPage /> </ProtectedRoute>
              } />
        <Route path="/add-official/:plantName/:id" element={<ProtectedRoute><AddOfficialsPage /></ProtectedRoute>} />
        <Route path="/edit-official/:plantName/:official_id/:cogen_id" element={<ProtectedRoute><EditOfficialsPage /></ProtectedRoute>} />
        <Route path="/technical-information/:plantName/:id" element={<ProtectedRoute><TechnicalPage /></ProtectedRoute>} />
        <Route path="/add-technical/:plantName/:cogen_id" element={<ProtectedRoute><AddTechnicalPage /></ProtectedRoute>} />
      <Route path="/edit-technical/:plantName/:technical_id/:cogen_id" element={<ProtectedRoute><EditTechnicalPage /></ProtectedRoute>} />
        <Route path="/performance-data/:plantName/:id" element={<ProtectedRoute><PerformDataPage /></ProtectedRoute>} />
        <Route path="/add-performance/:plantName/:id" element={<ProtectedRoute><AddNewPerformanceData /></ProtectedRoute>} />
        <Route path="/edit-performance/:performance_id" element={<ProtectedRoute><EditPerformDataPage /></ProtectedRoute>} />
        <Route path="/classifieds" element={<ProtectedRoute><ClassifiedPage /></ProtectedRoute>} />
        <Route path="/addclassified" element={<ProtectedRoute><AddClassifiedPage /></ProtectedRoute>} />
        <Route path="/editclassified/:classified/:id" element={<ProtectedRoute><EditClassifiedPage /></ProtectedRoute>} />
        <Route path="/suppliers" element={<ProtectedRoute><SupplierPage /></ProtectedRoute>} />
        <Route path="/addnewsupplier" element={<ProtectedRoute><AddSupplierPage /></ProtectedRoute>} />
        <Route path="/editsupplier/:Supplier/:id" element={<ProtectedRoute><EditSupplierPage /></ProtectedRoute>} />
        <Route path="/banners" element={<ProtectedRoute><BannerPage /></ProtectedRoute>} />
        <Route path="/addbanner" element={<ProtectedRoute><AddBannersPage /></ProtectedRoute>} />
        <Route path="/banners/:banner_id" element={<ProtectedRoute><ViewBannerPage /></ProtectedRoute>} />
        <Route path="/powergeneration" element={<ProtectedRoute><PowerGenerationPage /></ProtectedRoute>} />
        <Route path="/addpowergenerationplant" element={<ProtectedRoute><AddPowerGenerationPlantPage /></ProtectedRoute>} />
        <Route path="/updatepowergenerationplant/:plantName/:id" element={<ProtectedRoute><UpdatePowerGenerationPlantPage /></ProtectedRoute>} />
        <Route path="/powergenplant-officials/:plantName/:id" element={<ProtectedRoute><PowerOfficials /></ProtectedRoute>} />
        <Route path="/add-powergen-official/:plantName/:id" element={<ProtectedRoute><AddPowerOfficialsPage /></ProtectedRoute>} />
        <Route path="/edit-powergen-official/:plantName/:genofficial_id/:power_id" element={<ProtectedRoute><EditPowerOfficials /></ProtectedRoute>} />
        <Route path="/renewableagency" element={<ProtectedRoute><RenewableAgencyPage /></ProtectedRoute>} />
        <Route path="/addrenewableagency" element={<ProtectedRoute><AddRenewableAgencyPage /></ProtectedRoute>} />
        <Route path="/editrenewableagency/:plantName/:id" element={<ProtectedRoute><UpdateRenewableAgencyPage /></ProtectedRoute>} />
        <Route path="/renewableenergy" element={<ProtectedRoute><RenewableEnergyPage /></ProtectedRoute>} />
        <Route path="/addrenewableenergyplant" element={<ProtectedRoute><AddRenewableEnergyPage /></ProtectedRoute>} />
        <Route path="/editrenewableenergyplant/:plantName/:id" element={<ProtectedRoute><UpdateRenewableEnergyPage /></ProtectedRoute>} />
        <Route path="/powergenerationdashboard/:plantName/:id" element={<ProtectedRoute><PowerDashboardPage /></ProtectedRoute>} />
        <Route path="/powerperformance-data/:plantName/:id" element={<ProtectedRoute><PowerPerformanceDataPage /></ProtectedRoute>} />
        <Route path="/add-powerperformance/:plantName/:id" element={<ProtectedRoute><AddPerformanceDataPage /></ProtectedRoute>} />
        <Route path="/edit-powerperformance/:perform_id" element={<ProtectedRoute><EditPerformanceDataPage /></ProtectedRoute>} />
        <Route path="/renewableagencydashboard/:plantName/:id" element={<ProtectedRoute><AgencyDashboardPage /></ProtectedRoute>} />
        <Route path="/renewableagency-officials/:plantName/:id" element={<ProtectedRoute><AgencyOfficialsPage /></ProtectedRoute>} />
        <Route path="/add-agencyofficial/:plantName/:id" element={<ProtectedRoute><AddNewAgencyOfficialsPage /></ProtectedRoute>} />
        <Route path="/edit-agencyofficial/:plantName/:id/:official_id" element={<ProtectedRoute><EditAgencyOfficialsPage /></ProtectedRoute>} />
        <Route path="/renewableenergydashboard/:plantName/:id" element={<ProtectedRoute><EnergyDashboardPage /></ProtectedRoute>} />
        <Route path="/renewenergyplant-officials/:plantName/:id" element={<ProtectedRoute><EnergyOfficialPage /></ProtectedRoute>} />
        <Route path="/add-energyofficial/:plantName/:id" element={<ProtectedRoute><AddNewEnergyOfficialsPage /></ProtectedRoute>} />
        <Route path="/edit-energyofficial/:plantName/:id/:official_id/" element={<ProtectedRoute><EditEnergyOfficialsPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

      </Routes>
    </LayoutWrapper>
  );
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
   <App />
  </BrowserRouter>
);
